import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IconCloseInjectorComponent } from 'sharedGlobals/modals/templates/icon-close-injector.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, IconCloseInjectorComponent],
})
export class AppComponent {
    title = 'virseker';
    date: Date;
    isBrowser: boolean = false;

    constructor(@Inject(PLATFORM_ID) readonly platformId: Object) {
        if (isPlatformBrowser(platformId)) {
            this.isBrowser = true;
        }
    }
}
